import {HttpContextToken, HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError, throwError} from 'rxjs';
import {ToastService} from '@core/services/toast.service';
import {humanizeHttpError} from '@utils/http-error.util';

export const SKIP_HTTP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const isCoverOverlapWarning = error.status === 409 && Array.isArray(error.error?.coverWarnings) && error.error.coverWarnings.length > 0;
      if (error.status !== 401 && !isCoverOverlapWarning && !req.context.get(SKIP_HTTP_ERROR_TOAST)) {
        toast.error(humanizeHttpError(error));
      }
      return throwError(() => error);
    }),
  );
};
